import { render, staticRenderFns } from "./CalibrationTable.vue?vue&type=template&id=bef12bfc"
import script from "./CalibrationTable.vue?vue&type=script&lang=js"
export * from "./CalibrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports